import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { Name } from "@peculiar/asn1-x509";
let DomainName = class DomainName extends Name {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, Name.prototype);
    }
};
DomainName = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], DomainName);
export { DomainName };
